import { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { TTopicPathState } from '../../components/topicPath/type/Type';
import { TSiteTaskPageLocationState } from '../../types/task';

export const useHooks = () => {
  // locationから必要な情報を取り出し
  const params: any = useParams();
  const constructId: number = parseInt(params.constructId);
  const location = useLocation();
  const state = location.state as TSiteTaskPageLocationState;
  const siteProcessId = state?.siteProcessId || 0;
  const listMode = state?.listMode || false;

  const query = new URLSearchParams(useLocation().search);
  const viewAlertQueryDef = query.get('viewAlert') ?? '';

  const viewAlert = viewAlertQueryDef === 'true' ? true : state?.viewAlert;

  // パンくずリスト用に工事IDをセット
  const patternState: TTopicPathState = {};
  patternState['/processes'] = { constructId: constructId };

  return { constructId, siteProcessId, viewAlert, patternState, listMode };
};
